import { Box, SearchField, Text } from '@factorialco/deprecated-design-system'
import { startCase } from 'lodash'
import orderBy from 'lodash/orderBy'

import { observer } from 'mobx-react'

import ScrollableList from 'modules/core/components/ScrollableList'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { Policies } from 'modules/payroll_bundle/store/collections/policies'

interface Props {
  policies: Policies

  selectedPolicyId: string

  onChange: (policyId: string) => void
}

const PolicySelectorPopoverContent = ({ policies, selectedPolicyId, onChange }: Props) => {
  const { search, onSearch } = useDebouncedSearch()

  const filteredPolicies = policies.filter((policy) =>
    policy.attributes.name.toLowerCase().includes(search)
  )

  const isFilterPoliciesEmpty = filteredPolicies.length === 0

  return (
    <Box
      paddingBottom="s12"
      paddingX="s24"
      paddingTop="s24"
      aria-label={i18n.t(
        'payroll_bundle.payroll_policy.policy_period_selector.popover_selector_label' // TODO: Fix this label
      )}
    >
      <Box
        border={{ all: { color: 'grey200', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs008' }}
      >
        <Box width="full" background="grey200" padding="s8">
          <SearchField
            variant="big"
            search={search}
            onSearch={onSearch}
            placeholder={i18n.t('common.search')}
          />
        </Box>

        {isFilterPoliciesEmpty && (
          <Box alignItems="center" justifyContent="center" padding="s24">
            <Text.Normal>
              {
                i18n.t('payroll_bundle.payroll_policy.policy_period_selector.no_results') // TODO: Fix this label
              }
              Fix this label
            </Text.Normal>
          </Box>
        )}

        {!isFilterPoliciesEmpty && (
          <ScrollableList>
            <Box
              aria-label={i18n.t(
                'payroll_bundle.payroll_policy.policy_period_selector.popover_policy_period_list_label' // TODO: Fix this label
              )}
            >
              {orderBy(filteredPolicies, (policy) => policy.get('name').toLowerCase(), 'asc').map(
                (policy) => {
                  const isHighlighted = selectedPolicyId === policy.attributes.id

                  return (
                    <Box
                      justifyContent="center"
                      alignItems="flexStart"
                      padding="s16"
                      key={policy.id}
                      cursor="pointer"
                      onClick={() => onChange(policy.id)}
                      background={isHighlighted ? 'viridian100' : undefined}
                    >
                      <Text
                        size="300"
                        weight="medium"
                        color={isHighlighted ? 'viridian1200' : 'grey800'}
                      >
                        {i18n.t('payroll_bundle.payroll_policy.name', {
                          policyName: startCase(policy.attributes.name),
                        })}
                      </Text>
                    </Box>
                  )
                }
              )}
            </Box>
          </ScrollableList>
        )}
      </Box>
    </Box>
  )
}

export default observer(PolicySelectorPopoverContent)
